import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { useGetCurrentBoardId } from 'entities/user/api/hooks/useGetCurrentBoardId';
import { deleteBoardsDocuments } from '../requests';
import type { DeleteBoardsDocumentsRequestType } from '../types';

export type UseDeleteBoardsDocumentsMutationParams = Omit<
  DeleteBoardsDocumentsRequestType,
  'boardId'
> & {
  boardId?: number;
};

export const useDeleteBoardsDocuments = (specBoardId?: number) => {
  const queryClient = useQueryClient();
  const currentBoardId = useGetCurrentBoardId();
  const boardId = (specBoardId || currentBoardId) as number;

  return useMutation({
    mutationFn: (data: UseDeleteBoardsDocumentsMutationParams) =>
      deleteBoardsDocuments({
        ...data,
        boardId,
      }),
    onSuccess: (_, variables) =>
      Promise.all(
        variables.ids.map(documentId =>
          queryClient.invalidateQueries({
            queryKey: [API_QUERY_KEYS.document, { documentId }],
          }),
        ),
      ),
  });
};
